import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["source", "button"];
  static values = { successContent: String };

  connect() {
    this.buttonTarget = this.hasButtonTarget
      ? this.buttonTarget
      : this.element.querySelector("button");
  }

  copy() {
    // this.sourceTarget.select()
    // document.execCommand("copy")
    const text = this.sourceTarget.value || this.sourceTarget.innerText?.trim();
    navigator.clipboard.writeText(text).then(() => {
      this.showCopiedFeedback();
    });
  }

  copyTextarea() {
    //console.log('textarea', this.sourceTarget.select())
    // this.sourceTarget.select()
    // document.execCommand("copy")
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      this.showCopiedFeedback();
    });
  }

  showCopiedFeedback() {
    if (this.buttonTarget) {
      const originalHtml = this.buttonTarget.innerHTML;
      const originalDisabled = this.buttonTarget.disabled;

      // Check if we have a success content value
      const successContent =
        this.element.getAttribute("data-clipboard-success-content") ||
        "Copied!";

      // Update button content
      this.buttonTarget.innerHTML = `&nbsp; ${successContent}`;
      this.buttonTarget.disabled = true;

      // Restore after delay
      setTimeout(() => {
        this.buttonTarget.innerHTML = originalHtml;
        this.buttonTarget.disabled = originalDisabled;
      }, 1200);
    }
  }
}
